// extracted by mini-css-extract-plugin
export var deleteModal = "_g3-0";